import './instrument';
import './nexus';
import * as Sentry from '@sentry/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { notification } from 'antd';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import {
  AuthProvider,
  LanguageProvider,
  MaskingProvider,
  PageSettingsProvider,
  SampleProvider,
  ScannedKitsProvider,
} from './contexts';
import './locales/i18n';
//
import './init';
// import './init' must be above import App
import App from './App';
import { newQueryClient } from './queries/reactQueryConfig';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
//
dayjs.extend(utc);

notification.config({
  duration: 5,
});

ReactDOM.createRoot(
  (document.getElementById('root') ||
    document.createElement('div')) as HTMLElement,
).render(
  <Sentry.ErrorBoundary fallback={<p>An unexpected error occurred.</p>}>
    <QueryClientProvider client={newQueryClient}>
      <AuthProvider>
        <PageSettingsProvider>
          {/* <ExtractionProvider> */}
          <SampleProvider>
            <ScannedKitsProvider>
              <MaskingProvider>
                <BrowserRouter>
                  <LanguageProvider>
                    <App />
                  </LanguageProvider>
                </BrowserRouter>
              </MaskingProvider>
            </ScannedKitsProvider>
          </SampleProvider>
          {/* </ExtractionProvider> */}
        </PageSettingsProvider>
      </AuthProvider>
    </QueryClientProvider>
  </Sentry.ErrorBoundary>,
);
